import { type FC, type ReactNode } from 'react';
import { Card } from 'Card';
import { Text } from 'Text';

/*
    Sidebar chrome: caption, full-width divider, content. Uses Card dividers, not hr-hexagon. The parent owns the
    margins between boxes.
*/

type Props = {
    caption: string;
    children: ReactNode;
    className?: string;
};

export const SidebarBox: FC<Props> = ({ caption, children, className }) => (
    <Card
        width="full"
        radius={5}
        padding="compact-header"
        dividers={{ afterHeader: true }}
        header={
            <Text
                as="h3"
                color="black"
                weight="normal"
                className="m-0 w-full text-center text-lg leading-5 sm:leading-[25px]"
            >
                {caption}
            </Text>
        }
        className={className}
    >
        {/* A plain div, not Text: Text stamps its own colour, which would beat the inherited one. */}
        {/* text-start, not the text-left CardBody sets. That is a physical property, so it stays on the
            left in a right-to-left locale and drags every heading in here with it. */}
        <div className="text-start text-md text-black">{children}</div>
    </Card>
);
